import { HttpError } from "./HttpError";

export class DecodeError extends HttpError {
  constructor(response: Response, request: Request, ...params: any[]) {
    super(response, request, ...params);
  }

  get message() {
    return (
      super.message +
      " Die zurückgegebenen Daten entsprechen nicht dem erwarteten Format."
    );
  }
}
